/*
 * 企業側 案件詳細
 */
import { apiGetOne } from '@/actions/ApiBaseActions';
export const API_GET_ONE_CONSULTANT_SEARCH_EACH_COUNT_INQUIRY_THEMES = 'API_GET_ONE_CONSULTANT_SEARCH_EACH_COUNT_INQUIRY_THEMES';
/**
 * ご相談頂けるテーマそれぞれのコンサル/事例数の件数を取得
 */
export const apiGetOneConsultantSearchEachCountInquiryThemes = (_args = {}, meta) => apiGetOne(API_GET_ONE_CONSULTANT_SEARCH_EACH_COUNT_INQUIRY_THEMES, `/consultant_search/theme_count`, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
